import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '@anytag/shared-utils';

export interface SectionTitleProps extends React.ComponentProps<'div'> {
  index?: number;
  label?: string | null;
  size?: VariantProps<typeof styles.sectionVariants>['size'];
}

export const SectionTitle = ({ index, label, className, size = '24', children }: SectionTitleProps) => (
  <div className={cn('mb-3 flex items-center text-xl', className)}>
    {index ? (
      <div className={styles.sectionVariants({ size })}>
        <span className={styles.indexVariants({ size })}>{index}</span>
      </div>
    ) : null}
    <span className="text-xl font-semibold">{label}</span>
    {children}
  </div>
);

const styles = {
  sectionVariants: cva('mr-2 flex items-center rounded-full bg-black-90 text-center justify-center', {
    variants: {
      size: {
        '24': 'w-6 h-6',
        '20': 'w-5 h-5',
        '18': 'w-4.5 h-4.5'
      }
    }
  }),
  indexVariants: cva('font-semibold text-base text-white', {
    variants: {
      size: {
        '24': 'leading-6',
        '20': 'leading-5',
        '18': 'leading-4.5'
      }
    }
  })
};
